/* Danachi 2026 - touch gesture repair.

   The 3D scenes bind their drag teardown to 'pointerup' only. On a phone the
   page scroller can claim a gesture that began on the canvas and fire
   'pointercancel' instead - 'pointerup' never arrives, so the scene's
   `dragging` flag stays true for the rest of the visit. That matters more than
   it sounds: in both the hero and the showroom the idle rotation, the inertia
   decay and the parallax restore all live in the `else` branch of
   `if (dragging)`, so one cancelled swipe freezes the scene permanently.

   Both scenes listen for pointerup on `window`, so re-emitting one on cancel
   releases them cleanly and neither file has to change. */
(function () {
  if (typeof window === 'undefined' || !window.PointerEvent) return;

  window.addEventListener('pointercancel', function (e) {
    var init = {
      bubbles: true,
      cancelable: true,
      pointerId: e.pointerId,
      pointerType: e.pointerType,
      clientX: e.clientX,
      clientY: e.clientY
    };
    try {
      window.dispatchEvent(new PointerEvent('pointerup', init));
    } catch (err) {
      /* very old engines: a plain Event still satisfies the listeners above */
      window.dispatchEvent(new Event('pointerup'));
    }
  }, true);
})();
